import errorHandle from '../../../utils/errorHandle';
import { orgDateDetails, supCustomTripBookingFuc } from '../../../api/supportAdmin';
import { useParams } from 'react-router-dom';
import { getTypeOrg } from '../../../utils/getType';

export default async function fetchTripDateTable(setTripDateDetails, setLoading) {
    const orgId = window.location.pathname.split('/')[5];
    const dateId = window.location.pathname.split('/')[6];
    setLoading(true);
    try {
        const table = await orgDateDetails(orgId, dateId);
        setTripDateDetails(table.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export const fetchCustomTripDateTable = async (setTripDateDetails, setLoading) => {
    const type = window.location.pathname.split('/')[2];
    const packId = window.location.pathname.split('/')[5];
    const startDate = window.location.pathname.split('/')[6];
    setLoading(true);
    try {
        const table = await supCustomTripBookingFuc(getTypeOrg(type), packId, startDate);
        const normalizedData = table?.data?.map((item) => ({
            ...item,
            id: item?.actId || item?.guTourId || item?.packId,
            status: item?.actStatus || item?.guStatus || item?.tripStatus
        }));
        setTripDateDetails(normalizedData);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
